export const landingPath = () => '/tax/v2'
export const planningPath = () => '/tax/v2/planning'
export const editPlanningPath = () => '/tax/v2/planning/edit'
export const savingPlanningPath = () => '/tax/v2/planning/saving'
export const annuityPlanningPath = () => '/tax/v2/planning/annuity'
export const productDetailPath = (type, id) => `/tax/v2/product/${type}/${id}`
